import {
  projectName,
  projectNames,
} from '@/shared/constants/system';
import { projectSpecificResources } from '@/shared/constants/projectSpecificResources';
// @ts-ignore
import projectStyleVariables from '@project/assets/styles/variables/variables.module.scss';

export function useProjectSpecific() {
  return {
    projectName, // ID-строка текущего проекта
    projectNames, // Хэш всех проектов
    projectSpecificResources, // Ресурсы специфичные для текущего проекта
    projectStyleVariables,
  };
}
